module.exports = __webpack_public_path__ + "img/c08_unitbladechariot_Normal_ua.16ce26ec.webp";